import { render, staticRenderFns } from "./VendorSidebar.vue?vue&type=template&id=a1ac1866"
import script from "./VendorSidebar.vue?vue&type=script&lang=js"
export * from "./VendorSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports